import PropTypes from 'prop-types';
import { Button, Stack, Typography } from '@mui/material';

const timeFilterButtons = [
  { label: 'All time', value: 0 },
  { label: '3 months', value: 3 },
  { label: '6 months', value: 6 },
  { label: '12 months', value: 12 },
  { label: '18 months', value: 18 },
];

const styles = {
  button: { borderRadius: 6, minWidth: 100 },
};

export const LineChartFilterButtons = ({ chartMonths, setChartMonths }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent={{ xs: 'space-around', md: 'center' }}
    gap={{ xs: 3, md: 8, xl: 3 }}
    pl={{ xs: 3, md: 0 }}
  >
    {timeFilterButtons.map(({ label, value }) => {
      const isActive = value === chartMonths;

      return (
        <Button
          key={value}
          onClick={() => setChartMonths(value)}
          size="small"
          variant={isActive ? 'contained' : 'text'}
          color={isActive ? 'primary' : 'inherit'}
          sx={styles.button}
        >
          <Typography variant="body2" color={isActive ? 'text.secondary' : 'text.primary'} align="center">
            {label}
          </Typography>
        </Button>
      );
    })}
  </Stack>
);

LineChartFilterButtons.propTypes = {
  chartMonths: PropTypes.number.isRequired,
  setChartMonths: PropTypes.func.isRequired,
};
